export default __webpack_public_path__ + "static/cruiselines-carnival-ship-1-b002ee17ac30dd0209ee2d8e11a96524.jpg";